import React, {useEffect} from 'react';
import {isIphoneX} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useTheme} from 'styled-components/native';

import {Container, Title, CloseButton, CloseIcon} from './styles';

interface IToast {
  type: 'error' | 'success' | 'info' | 'warning';
  text: string;
  timeout: number;
  onEnd: () => void;
}

export function Toast({type, text, timeout, onEnd}: IToast) {
  const theme = useTheme();

  let typeColor;

  switch (type) {
    case 'error':
      typeColor = theme.colors.attention;
      break;
    case 'success':
      typeColor = theme.colors.success;
      break;
    case 'info':
      typeColor = theme.colors.blue;
      break;
    case 'warning':
      typeColor = theme.colors.yellow;
      break;
    default:
      typeColor = theme.colors.blue;
      break;
  }

  useEffect(() => {
    let isMounted = true;

    setTimeout(() => {
      if (isMounted) {
        onEnd();
        isMounted = false;
      }
    }, timeout);

    return () => {
      isMounted = false;
    };
  }, []);

  function closeAction() {
    onEnd();
  }

  return (
    <Container
      style={{
        backgroundColor: typeColor,
      }}>
      <SafeAreaView
        style={{
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: RFValue(12),
          paddingBottom: isIphoneX() ? -RFValue(12) : RFValue(12),
        }}>
        <Title>{text}</Title>
        <CloseButton onPress={closeAction} activeOpacity={1}>
          <CloseIcon name="x" />
        </CloseButton>
      </SafeAreaView>
    </Container>
  );
}
